import LinkTabContent from './LinkTabContent'
export default LinkTabContent
